<form [formGroup]="emailForm" role="form">
  <div class="input-self w-100" *transloco="let t">
    <label for="email" class="form-label">{{labelTextTranslationKey ? t(labelTextTranslationKey) : labelText}}
      <!-- <span class="required-sign">*</span> -->
    </label>
    <div class="input-group w-100"
      [class.ng-invalid]="
        emailForm.get('email').invalid &&
        (emailForm.get('email').touched ||
        emailForm.get('email').dirty)
      "
      [class.ng-valid]="
        emailForm.get('email').valid &&
        emailForm.get('email').touched &&
        emailForm.get('email').dirty
      ">
      <input class="form-control" type="email" formControlName="email" id="email" placeholder="example@email.com" />
      <button [disabled]="!emailForm.valid || loading" (click)="submit()" class="btn btn-sm btn-primary primary-dark"
        type="button" id="button-addon2">
        {{t('common.submit')}}
      </button>
    </div>
    @if (loading) {
      <multisite-loader-globe-animation-detail [width]="60" [height]="60">
      </multisite-loader-globe-animation-detail>
    }
    @if (
      emailForm.get('email').errors?.email && emailForm.get('email').touched
      ) {
      <div class="invalid-feedback">
        {{ t('authentication.invalid_address') }}
      </div>
    }
    @if (
      emailForm.get('email').errors?.required &&
      emailForm.get('email').dirty
      ) {
      <div class="invalid-feedback">
        {{ t('common.required') }}
      </div>
    }
    @if (errorTranslationKey) {
      <div class="text-danger" [innerHTML]="t(errorTranslationKey)"></div>
    }
  </div>
</form>